module.exports = __webpack_public_path__ + "img/usa 250 transparent.c8f17cdf.jpg";